module.exports = __webpack_public_path__ + "static/img/choose_bg_top.5f7de134.png";